import React, { Component } from "react";
import { Form, Input, Button, DatePicker, Select } from 'antd';

const { RangePicker } = DatePicker;
const { Option } = Select;

class App extends Component {

  	handleSubmit = (e) => {
    	e.preventDefault();
    	this.props.form.validateFields((err, values) => {
      		if (!err) {
        		console.log('Received values of form: ', values);
        		if(values.finishTime){
        			values.submitBeginTime = values.finishTime[0].format("YYYY-MM-DD");
        			values.submitEndTime = values.finishTime[1].format("YYYY-MM-DD");
        			values.finishTime = undefined;
        		}
        		if(values.startTime){
        			values.startBeginTime = values.startTime[0].format("YYYY-MM-DD");
        			values.startEndTime = values.startTime[1].format("YYYY-MM-DD");
        			values.startTime = undefined;
        		}
        		if(values.endTime){
        			values.finishBeginTime = values.endTime[0].format("YYYY-MM-DD");
        			values.finishEndTime = values.endTime[1].format("YYYY-MM-DD");
        			values.endTime = undefined;
        		}
        		typeof this.props.handleFormSubmit === "function" && this.props.handleFormSubmit(values);
      		}
    	});
  	}

  	handleReset = () => {
  		this.props.form.resetFields();
  		typeof this.props.handleFormReset === "function" && this.props.handleFormReset();
  	}

  	render() {
    	const { getFieldDecorator } = this.props.form;
    	const formItemLayout = {
      		labelCol: {
        		xs: { span: 24 },
        		sm: { span: 8 },
      		},
      		wrapperCol: {
        		xs: { span: 24 },
        		sm: { span: 16 },
      		}
    	};

    	return (
    		<Form onSubmit={this.handleSubmit} className="list-screen-form-wrap">
    			<div className="list-screen-form">
    				<Form.Item {...formItemLayout} label="候选人姓名">
			          	{getFieldDecorator('userName')(
					        <Input placeholder="请输入候选人姓名" />
						)}
			        </Form.Item>
			        <Form.Item {...formItemLayout} label="code">
			          	{getFieldDecorator('corpCode')(
					        <Input placeholder="code" />
						)}
			        </Form.Item>
			        <Form.Item {...formItemLayout} label="录制状态">
			          	{getFieldDecorator('status')(
			            	<Select
				              	placeholder="请选择"
				            >
				              <Option value="">请选择</Option>
				              <Option value="0">未开始</Option>
				              <Option value="1">已完成</Option>
				              <Option value="2">进行中</Option>
				              <Option value="5">账号无效</Option>
				            </Select>
			          	)}
			        </Form.Item>
			        <Form.Item {...formItemLayout} label="提交情况">
			          	{getFieldDecorator('submitStatus')(
			            	<Select
				              	placeholder="请选择"
				            >
				              <Option value="">请选择</Option>
				              <Option value="1">次数耗尽</Option>
				              <Option value="2">过期未提交</Option>
				              <Option value="3">过期未开始</Option>
				              <Option value="4">完整提交</Option>
				            </Select>
			          	)}
			        </Form.Item>
			        <Form.Item {...formItemLayout} label="视频文件状态">
			          	{getFieldDecorator('fileStatus')(
			            	<Select
				              	placeholder="请选择"
				            >
				              <Option value="">请选择</Option>
				              <Option value="0">存在</Option>
				              <Option value="1">不存在</Option>
				            </Select>
			          	)}
			        </Form.Item>
			        <Form.Item {...formItemLayout} label="视频来源">
			          	{getFieldDecorator('videoResource')(
			            	<Select
				              	placeholder="请选择"
				            >
				              <Option value="">请选择</Option>
				              <Option value="1">小程序</Option>
				              <Option value="2">PC</Option>
				            </Select>
			          	)}
			        </Form.Item>
			        <Form.Item {...formItemLayout} label="共享费用账户">
			          	{getFieldDecorator('paidAccountId')(
			            	<Input placeholder="请输入共享费用账户" />
			          	)}
			        </Form.Item>
			        <Form.Item {...formItemLayout} label="所属机构">
			          	{getFieldDecorator('orgName')(
			            	<Input placeholder="请输入所属机构" />
			          	)}
			        </Form.Item>
			        <Form.Item {...formItemLayout} label="交卷时间">
			          	{getFieldDecorator('finishTime')(
					        <RangePicker />
						)}
			        </Form.Item>
			        <Form.Item {...formItemLayout} label="面试开始时间">
			          	{getFieldDecorator('startTime')(
					        <RangePicker />
						)}
			        </Form.Item>
			        <Form.Item {...formItemLayout} label="面试结束时间">
			          	{getFieldDecorator('endTime')(
					        <RangePicker />
						)}
			        </Form.Item>
    			</div>
		      	<div className="list-screen-form-btns">
		      		<Button htmlType="reset" onClick={this.handleReset}>清空</Button>
		      		<Button type="primary" htmlType="submit">查询</Button>
		      	</div>
	      	</Form>
		);
	}
}

const WrappedNormalLoginForm = Form.create()(App);

export default WrappedNormalLoginForm;